/*
  Carrinho lateral nativo — <toda-cart-drawer> (sections/cart-drawer.liquid).
  Regra de ouro: o estado vem do Liquid. Depois de cada chamada ao carrinho pedimos a seção
  renderizada (/?sections=cart-drawer) e trocamos o HTML. Nada de total calculado aqui.
*/
(function () {
  'use strict';
  if (window.customElements.get('toda-cart-drawer')) return;

  var SECTION = 'cart-drawer';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])';

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }
  function api(method, path, body) {
    return fetch(root() + path, {
      method: method,
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); });
  }

  class TodaCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._open = false;
      this._busy = false;
      this._lastFocus = null;
      this._giftLock = false;

      // Delegação no elemento: sobrevive ao re-render.
      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('change', this._onChange.bind(this));
      this.addEventListener('scroll', function (e) { if (e.target && e.target.matches && e.target.matches('[data-tcd-cross-row]')) this._crossUpdate(); }.bind(this), true);
      this.addEventListener('submit', this._onSubmit.bind(this));
      this.addEventListener('keydown', this._onKeydown.bind(this));

      // Gatilho no header: o ícone abre a gaveta; o link /cart continua como reserva sem JS.
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[aria-controls="mini-cart"], a[href$="/cart"], a[href="' + root() + '/cart"]');
        if (!a || !a.closest('.header, header, #shopify-section-header, store-header')) return;
        e.preventDefault(); e.stopPropagation();
        this.open();
      }.bind(this), true);

      // Depois de qualquer adição (formulário do tema, Kit Exclusivo, quick-buy): re-renderiza e abre.
      document.addEventListener('cart-notification:show', function (e) {
        if (!e.detail || e.detail.status !== 'success') return;
        e.stopPropagation(); e.preventDefault(); // silencia a notificação do tema
        this.refresh({ open: true });
      }.bind(this), true);
      document.addEventListener('cart:refresh', function (e) {
        if (e.target === this || (e.detail && e.detail.source === 'toda-cart')) return;
        this.refresh({ open: !!(e.detail && e.detail.openMiniCart) });
      }.bind(this));

      // Editor de temas recarrega a seção isolada.
      document.addEventListener('shopify:section:load', function (e) {
        if (e.detail && e.detail.sectionId === this.dataset.sectionId) this._afterRender();
      }.bind(this));
      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open();
      }.bind(this));

      this._afterRender();
    }

    /* ---------- abrir / fechar ---------- */
    open() {
      if (this._open) return;
      this._open = true;
      this._lastFocus = document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tcd-lock');
      var panel = this.querySelector('.tcd__panel');
      if (panel) setTimeout(function () { panel.focus(); }, 60);
      this.dispatchEvent(new CustomEvent('toda-cart:open', { bubbles: true }));
    }
    close() {
      if (!this._open) return;
      this._open = false;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tcd-lock');
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
      this.dispatchEvent(new CustomEvent('toda-cart:close', { bubbles: true }));
    }

    /* ---------- eventos ---------- */
    _onKeydown(e) {
      if (!this._open) return;
      if (e.key === 'Escape') { e.preventDefault(); if (this.querySelector('[data-tcd-bn-pop]')) this._bnPopClose(); else this.close(); return; }
      if (e.key !== 'Tab') return;
      var nodes = Array.prototype.filter.call(this.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.querySelector('.tcd__panel'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    _onClick(e) {
      var el = e.target.closest('[data-tcd-action]');
      if (!el) return;
      var action = el.dataset.tcdAction;
      if (action === 'bnpop-guia') {
        e.preventDefault(); var bx = this.querySelector('.tcd__bnpop-box'), gd = bx && bx.querySelector('.tcd__bnpop-guia');
        if (gd) { var abrir = gd.hidden; gd.hidden = !abrir; bx.classList.toggle('is-guia', abrir); if (abrir) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'bn_popup_guia_medidas' }); } catch (err) {} } }
        return;
      }
      if (action === 'bnpop-close') { e.preventDefault(); this._bnPopClose(); return; }
      if (action === 'bnpop-skip') {
        e.preventDefault(); this._bnPopClose(); this._bnAviso = true;
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'bn_popup_sem_presente' }); } catch (err) {}
        var cfs = this.querySelector('.tcd__checkout-form');
        if (cfs) { if (cfs.requestSubmit) cfs.requestSubmit(); else cfs.submit(); }
        return;
      }
      if (action === 'close') { e.preventDefault(); this.close(); return; }
      if (this._busy) return;
      var key = el.dataset.key;
      if (action === 'minus' || action === 'plus') {
        var input = this.querySelector('[data-tcd-qty-input][data-key="' + key + '"]');
        var q = parseInt(input && input.value, 10) || 1;
        this.changeLine(key, action === 'plus' ? q + 1 : q - 1);
      } else if (action === 'remove') {
        this.changeLine(key, 0);
      } else if (action === 'cross-prev' || action === 'cross-next') {
        var crow = this.querySelector('[data-tcd-cross-row]');
        if (crow) crow.scrollBy({ left: (action === 'cross-next' ? 1 : -1) * crow.clientWidth * 0.9, behavior: 'smooth' });
      } else if (action === 'cross-add') {
        var card = el.closest('.tcd__cross-card');
        var sel = card && card.querySelector('[data-tcd-cross-variant]');
        var vid = parseInt((sel && sel.value) || el.dataset.variantId, 10);
        var json = card && card.querySelector('[data-tcd-cross-json]');
        if (json) {
          var vars = []; try { vars = JSON.parse(json.textContent); } catch (err) {}
          var vals = Array.prototype.map.call(card.querySelectorAll('[data-tcd-cross-opt]'), function (s) { return s.value; });
          var achou = vars.filter(function (v) { return vals.every(function (x, i) { return v.o[i] === x; }); })[0];
          if (!achou || !achou.a) { this._toast('Essa combinação está esgotada.'); return; }
          vid = achou.id;
        }
        if (!vid) { this._toast('Escolha a opção do produto.'); return; }
        this.addItem(vid, { _origem: 'carrinho-upsell' });
      } else if (action === 'coupon-toggle') {
        var form = this.querySelector('[data-tcd-coupon-form]');
        var abrir = form && form.hidden;
        if (form) form.hidden = !abrir;
        el.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        var lbl = el.querySelector('.tcd__coupon-toggle-right'); if (lbl) lbl.textContent = abrir ? 'Fechar' : 'Adicionar';
        if (abrir) { var inp = form.querySelector('[data-tcd-coupon-input]'); if (inp) inp.focus(); }
      } else if (action === 'coupon-remove') {
        this.applyCoupon('');
      } else if (action === 'ship-clear') {
        this._shipHtml = null; this._renderShip();
      } else if (action === 'upsell-open') {
        var body = el.parentElement.querySelector('.tcd__upsell-body');
        var abrir = body && body.hidden;
        if (body) body.hidden = !abrir;
        el.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        if (abrir) { var sel = body.querySelector('select'); if (sel) sel.focus(); }
        return;
      } else if (action === 'kit-activate') {
        this.activateKit(el.dataset.kit, el.dataset.tier, el.dataset.keys);
      }
    }
    /* ---------- upsell do Kit Exclusivo (mesmas propriedades que o widget da PDP grava) ---------- */
    _kitProps(kit, tier, brinde) {
      var p = {};
      if (kit) { p._kit = kit; p._kit_tier = tier || ''; }
      if (brinde) p._brinde = 'sim';
      return p;
    }
    _setKitOnLines(keys, kit, tier) {
      var lista = (keys || '').split(',').filter(Boolean);
      var props = this._kitProps(kit, tier);
      var chain = Promise.resolve();
      // cada item vem como "chave~quantidade": o change.js sem quantity zera para 1
      lista.forEach(function (par) {
        var partes = par.split('~'), key = partes[0], qty = parseInt(partes[1], 10);
        var body = { id: key, properties: props };
        if (qty > 0) body.quantity = qty;
        chain = chain.then(function () { return api('POST', '/cart/change.js', body); });
      });
      return chain;
    }
    activateKit(kit, tier, keys) {
      if (!kit) return;
      this.setBusy(true);
      return this._setKitOnLines(keys, kit, tier)
        .then(function () { return this.refresh({ open: false }); }.bind(this))
        .catch(function () { this.setBusy(false); this._toast('Não foi possível ativar o desconto.'); }.bind(this));
    }
    upsellAdd(form) {
      var variants; try { variants = JSON.parse((form.querySelector('[data-tcd-variants]') || {}).textContent || '[]'); } catch (e) { variants = []; }
      var cpos = parseInt(form.dataset.cpos, 10), spos = parseInt(form.dataset.spos, 10);
      var cor = (form.querySelector('[data-tcd-upsell-color]') || {}).value;
      var tam = (form.querySelector('[data-tcd-upsell-size]') || {}).value;
      if (spos >= 0 && !tam) { this._toast('Escolha o tamanho.'); return; }
      var v = variants.filter(function (x) {
        var o = x[1] || [];
        return (cpos < 0 || o[cpos] === cor) && (spos < 0 || o[spos] === tam);
      })[0];
      if (!v) { this._toast('Combinação indisponível.'); return; }
      if (!v[2]) { this._toast('Essa cor/tamanho está esgotada.'); return; }
      var kit = form.dataset.kit, tier = form.dataset.tier, brinde = form.dataset.brinde === '1';
      var faixa = /^faixa\d$/.test(form.dataset.brinde || '') ? form.dataset.brinde : '';
      this.setBusy(true);
      return api('POST', '/cart/add.js', { items: [{ id: v[0], quantity: 1, properties: faixa ? { _brinde_auto: faixa } : this._kitProps(kit, tier, brinde) }] })
        .then(function (r) {
          if (!r.ok) { this._toast(r.json.description || r.json.message || 'Não foi possível adicionar.'); return; }
          return this._setKitOnLines(form.dataset.keys, kit, tier);
        }.bind(this))
        .then(function () { return this.refresh({ open: true }); }.bind(this))
        .catch(function () { this.setBusy(false); }.bind(this));
    }
    /* ---------- upsell em carrossel: seletores de opção e setas/bolinhas ---------- */
    _crossSync(card, changed) {
      if (!card) return;
      var json = card.querySelector('[data-tcd-cross-json]'); if (!json) return;
      var vars = []; try { vars = JSON.parse(json.textContent); } catch (err) {}
      var sels = card.querySelectorAll('[data-tcd-cross-opt]');
      if (sels.length < 2) return;
      // ao trocar a 1ª opção (cor), a 2ª (tamanho) pula para o primeiro disponível dessa cor e marca os esgotados
      var first = sels[0].value, second = sels[1];
      var disp = vars.filter(function (v) { return v.o[0] === first; });
      Array.prototype.forEach.call(second.options, function (o) {
        var v = disp.filter(function (x) { return x.o[1] === o.value; })[0];
        o.disabled = !v || !v.a;
      });
      var atual = second.options[second.selectedIndex];
      if (changed === sels[0] && (!atual || atual.disabled)) {
        var ok = Array.prototype.filter.call(second.options, function (o) { return !o.disabled; })[0];
        if (ok) second.value = ok.value;
      }
    }
    // troca a foto do cartão pela foto da variante (cor) escolhida
    _crossImage(card) {
      if (!card) return;
      var json = card.querySelector('[data-tcd-cross-json]'), img = card.querySelector('.tcd__cross-img img'); if (!json || !img) return;
      var vars = []; try { vars = JSON.parse(json.textContent); } catch (err) {}
      var vals = Array.prototype.map.call(card.querySelectorAll('[data-tcd-cross-opt]'), function (s) { return s.value; });
      var v = vars.filter(function (x) { return x.i && vals.every(function (val, i) { return x.o[i] === val; }); })[0]
        || vars.filter(function (x) { return x.i && x.o[0] === vals[0]; })[0];
      if (v && v.i && img.getAttribute('src') !== v.i) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = v.i; }
    }
    _crossUpdate() {
      var row = this.querySelector('[data-tcd-cross-row]'); if (!row) return;
      var cards = row.querySelectorAll('.tcd__cross-card');
      var arrows = this.querySelector('[data-tcd-cross-arrows]');
      var multi = cards.length > 1;
      if (arrows) {
        arrows.hidden = !multi;
        if (multi) {
          var idx = 0, best = 1e9;
          Array.prototype.forEach.call(cards, function (c, i) { var d = Math.abs(c.offsetLeft - row.offsetLeft - row.scrollLeft); if (d < best) { best = d; idx = i; } });
          var prev = arrows.querySelector('[data-tcd-action="cross-prev"]'), next = arrows.querySelector('[data-tcd-action="cross-next"]');
          if (prev) prev.disabled = idx <= 0;
          if (next) next.disabled = idx >= cards.length - 1;
        }
      }
    }
    _onChange(e) {
      // Black November: a foto do presente acompanha a cor escolhida
      var bnc = e.target.closest && e.target.closest('[data-tcd-bn-gift],[data-tcd-bn-pop]');
      if (bnc && e.target.matches('[data-tcd-upsell-color]')) {
        try {
          var mapa = JSON.parse(bnc.dataset.imgs || '{}'), im = bnc.querySelector('.tcd__bn-img img, .tcd__bnpop-img img');
          if (im && mapa[e.target.value]) { im.removeAttribute('srcset'); im.src = mapa[e.target.value]; }
        } catch (err) {}
        return;
      }
      var opt = e.target.closest && e.target.closest('[data-tcd-cross-opt]');
      if (opt) { var cc = opt.closest('.tcd__cross-card'); this._crossSync(cc, opt); this._crossImage(cc); return; }
      var input = e.target.closest('[data-tcd-qty-input]');
      if (!input) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 1;
      this.changeLine(input.dataset.key, q);
    }
    _onSubmit(e) {
      // Black November: o presente por faixa NÃO entra sozinho (a cliente escolhe o tamanho). Se ela tentar finalizar com o presente liberado e ainda não adicionado, avisa uma vez.
      var cf = e.target.closest && e.target.closest('.tcd__checkout-form');
      if (cf) {
        var pend = this.querySelectorAll('[data-tcd-bn-gift]');
        if (pend.length && !this._bnAviso) {
          e.preventDefault();
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'bn_presente_aviso', pendentes: pend.length }); } catch (err) {}
          this._bnPopup(true);
          return;
        }
        if (pend.length) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'bn_finalizou_sem_presente', pendentes: pend.length }); } catch (err) {} }
        return;
      }
      var up = e.target.closest('[data-tcd-upsell-form]');
      if (up) {
        e.preventDefault();
        var pop = up.closest('[data-tcd-bn-pop]');
        if (pop) {
          var sz = up.querySelector('[data-tcd-upsell-size]'), er = pop.querySelector('.tcd__bnpop-erro');
          if (sz && !sz.value) { if (er) { er.textContent = 'Escolha o tamanho para adicionar o presente.'; er.hidden = false; } sz.focus(); return; }
        }
        if (!this._busy) this.upsellAdd(up);
        return;
      }
      var ship = e.target.closest('[data-tcd-ship-form]');
      if (ship) {
        e.preventDefault();
        var cep = ((ship.querySelector('[data-tcd-ship-cep]') || {}).value || '').replace(/\D/g, '');
        if (cep.length !== 8) { this._shipMessage('Digite um CEP com 8 números.'); return; }
        this.estimateShipping(cep);
        return;
      }
      var form = e.target.closest('[data-tcd-coupon-form]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('[data-tcd-coupon-input]');
      var code = (input.value || '').trim().toUpperCase();
      if (!code) { this._couponMessage('Digite um cupom.', false); return; }
      this.applyCoupon(code);
    }

    /* ---------- chamadas ao carrinho ---------- */
    setBusy(v) { this._busy = v; this.classList.toggle('is-busy', v); }

    changeLine(key, quantity) {
      if (!key) return;
      this.setBusy(true);
      return api('POST', '/cart/change.js', { id: key, quantity: quantity })
        .then(function (r) {
          if (!r.ok) this._toast(r.json.description || r.json.message || 'Não foi possível atualizar o carrinho.');
          return this.refresh({ open: false });
        }.bind(this))
        .catch(function () { this.setBusy(false); }.bind(this));
    }

    addItem(variantId, properties) {
      this.setBusy(true);
      return api('POST', '/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: properties || {} }] })
        .then(function (r) {
          if (!r.ok) this._toast(r.json.description || r.json.message || 'Não foi possível adicionar.');
          return this.refresh({ open: true });
        }.bind(this))
        .catch(function () { this.setBusy(false); }.bind(this));
    }

    applyCoupon(code) {
      this._scrollAlvo = '[data-tcd-coupon]';
      this.setBusy(true);
      var btn = this.querySelector('[data-tcd-coupon-submit]'); if (btn) btn.disabled = true;
      return api('POST', '/cart/update.js', { discount: code })
        .then(function () { return api('GET', '/cart.js'); })
        .then(function (r) {
          var codes = (r.json && r.json.discount_codes) || [];
          if (code) {
            var mine = codes.filter(function (c) { return c.code.toUpperCase() === code; })[0];
            if (!mine || !mine.applicable) {
              // Recusado: tira do carrinho e avisa sem citar nenhum código (evita virar canal de distribuição).
              // Com um kit no carrinho, o motivo mais comum é o desconto do kit ser maior: explica em vez de "inválido".
              // A Shopify devolve applicable:false tanto para cupom inexistente quanto para cupom que não vale
              // para esses produtos ou que perde para o desconto automático do kit. A mensagem segue o carrinho:
              //  - sem kit: o cupom não vale para os produtos (ou não existe);
              //  - só kit (+ brindes): o desconto do kit já é maior;
              //  - misto: pode ser qualquer um dos dois.
              var itens = (r.json && r.json.items) || [];
              var linhasKit = itens.filter(function (i) { return i.properties && i.properties._kit; }).length;
              var linhasAvulsas = itens.filter(function (i) { return !(i.properties && (i.properties._kit || i.properties._brinde)); }).length;
              return api('POST', '/cart/update.js', { discount: '' }).then(function () {
                if (linhasKit && !linhasAvulsas) {
                  this._pendingCouponMsg = { text: '✅ Seu kit já tem o desconto aplicado direto no preço. O cupom não soma com ele.', ok: 'kit' };
                } else if (linhasKit) {
                  this._pendingCouponMsg = { text: 'Este cupom não foi aplicado: ele não vale para estes produtos ou o desconto do kit já é maior.', ok: false };
                } else {
                  this._pendingCouponMsg = { text: 'Este cupom não é válido para os produtos do seu carrinho.', ok: false };
                }
                return this.refresh({ open: false });
              }.bind(this));
            }
            this._pendingCouponMsg = { text: 'Cupom aplicado! Ele já vale no checkout.', ok: true };
          }
          return this.refresh({ open: false });
        }.bind(this))
        .catch(function () { this.setBusy(false); }.bind(this));
    }

    /* ---------- re-render pela Section Rendering API ---------- */
    refresh(opts) {
      opts = opts || {};
      this.setBusy(true);
      var self = this;
      // guarda a posição de rolagem e o estado do cupom: trocar o HTML não pode "voltar pro início"
      var bodyAntes = this.querySelector('[data-tcd-body]');
      var scrollAntes = bodyAntes ? bodyAntes.scrollTop : 0;
      var formAntes = this.querySelector('[data-tcd-coupon-form]');
      var cupomAberto = !!(formAntes && !formAntes.hidden);
      return fetch(root() + '/?sections=' + SECTION, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json[SECTION] || '';
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('toda-cart-drawer');
          if (fresh) {
            self.innerHTML = fresh.innerHTML;
            Array.prototype.forEach.call(fresh.attributes, function (a) { if (a.name.indexOf('data-') === 0) self.setAttribute(a.name, a.value); });
          }
          self.setBusy(false);
          self._bnAviso = false;
          if (cupomAberto) {
            var form = self.querySelector('[data-tcd-coupon-form]'), toggle = self.querySelector('[data-tcd-coupon-toggle]');
            if (form) form.hidden = false;
            if (toggle) { toggle.setAttribute('aria-expanded', 'true'); var lbl = toggle.querySelector('.tcd__coupon-toggle-right'); if (lbl) lbl.textContent = 'Fechar'; }
          }
          // restaura a rolagem depois do layout (imagens lazy mudam a altura): agora, no próximo frame e após 350 ms
          var restaurar = function () {
            var bodyDepois = self.querySelector('[data-tcd-body]');
            if (!bodyDepois) return;
            if (self._scrollAlvo) { var alvo = self.querySelector(self._scrollAlvo); if (alvo) { alvo.scrollIntoView({ block: 'center' }); return; } }
            if (scrollAntes) bodyDepois.scrollTop = scrollAntes;
          };
          restaurar(); requestAnimationFrame(restaurar); setTimeout(function () { restaurar(); self._scrollAlvo = null; }, 350);
          self._afterRender();
          if (opts.open) self.open();
          // avisa o tema (contador do header) sem re-disparar a nós mesmos
          return api('GET', '/cart.js').then(function (r) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: r.json, source: 'toda-cart' } }));
            self._renderCoupons(r.json);
            self._applyGiftRules(r.json);
            self._applyFaixas(r.json);
          });
        })
        .catch(function () { self.setBusy(false); });
    }

    /* ---------- Black November: popup do presente liberado ---------- */
    _bnPopClose() { var m = this.querySelector('[data-tcd-bn-pop]'); if (m) m.remove(); }
    _bnPopup(force) {
      var cards = this.querySelectorAll('[data-tcd-bn-gift]');
      if (!cards.length) { this._bnPopVisto = ''; this._bnPopClose(); return; }
      var card = cards[0], form = card.querySelector('.tcd__upsell-form'); if (!form) return;
      var sig = form.dataset.brinde || '1';
      if (!force && this._bnPopVisto === sig) return;
      this._bnPopVisto = sig;
      this._bnPopClose();
      var tit = /calcinha/i.test(card.querySelector('.tcd__bn-name').textContent) ? 'Calcinha Fio Dental SkinUp' : 'Protetor de Silicone Ultrafino';
      var img = card.querySelector('.tcd__bn-img img');
      var m = document.createElement('div');
      m.className = 'tcd__bnpop'; m.setAttribute('data-tcd-bn-pop', ''); m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
      try { m.dataset.imgs = card.dataset.imgs || '{}'; } catch (err) {}
      m.innerHTML = '<div class="tcd__bnpop-box">' +
        '<button type="button" class="tcd__bnpop-x" data-tcd-action="bnpop-close" aria-label="Fechar">&times;</button>' +
        '<p class="tcd__bnpop-eyebrow">Presente desbloqueado</p>' +
        '<h3 class="tcd__bnpop-title">Você ganhou ' + (sig === 'faixa2' ? 'um Protetor de Silicone' : 'uma Calcinha') + ' de presente!</h3>' +
        '<div class="tcd__bnpop-img"></div>' +
        '<p class="tcd__bnpop-name">' + tit + ' <span class="tcd__bn-free">GRÁTIS</span></p>' +
        '<p class="tcd__bnpop-hint">Escolha a cor e o tamanho e toque em adicionar. Sem essa escolha o presente não entra no seu pedido.</p>' +
        '<div class="tcd__bnpop-form"></div>' +
        (card.dataset.guia ? '<button type="button" class="tcd__bnpop-guia-link" data-tcd-action="bnpop-guia">Guia de medidas</button>' : '') +
        '<p class="tcd__bnpop-erro" role="alert" hidden></p>' +
        '<button type="button" class="tcd__bnpop-skip" data-tcd-action="bnpop-skip">Continuar sem o presente</button>' +
        (card.dataset.guia ? '<div class="tcd__bnpop-guia" hidden><img src="' + card.dataset.guia.replace(/"/g, '') + '" alt="Guia de medidas"><button type="button" class="tcd__bnpop-voltar" data-tcd-action="bnpop-guia">Voltar</button></div>' : '') +
        '</div>';
      if (img) m.querySelector('.tcd__bnpop-img').appendChild(img.cloneNode(true));
      var f = form.cloneNode(true);
      var sel = form.querySelectorAll('select'), csel = f.querySelectorAll('select');
      Array.prototype.forEach.call(csel, function (c, i) { if (sel[i]) c.value = sel[i].value; });
      var b = f.querySelector('.tcd__upsell-btn'); if (b) b.textContent = 'Adicionar ao carrinho';
      m.querySelector('.tcd__bnpop-form').appendChild(f);
      this.appendChild(m);
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'bn_popup_presente', faixa: sig, forcado: !!force }); } catch (err) {}
    }

    _afterRender() {
      this._startTimer();
      this._crossUpdate();
      var selfP = this; setTimeout(function () { if (selfP.classList.contains('is-open')) selfP._bnPopup(false); }, 450);
      // o valor do carrinho mudou? recalcula o frete do mesmo CEP em silêncio
      if (this._shipCep && this._ultimoTotalFrete !== this.dataset.total) { this._ultimoTotalFrete = this.dataset.total; this._shipHtml = null; this._renderShip(); this.estimateShipping(this._shipCep); }
      else this._renderShip();
      var msg = this._pendingCouponMsg; this._pendingCouponMsg = null;
      if (msg) this._couponMessage(msg.text, msg.ok);
      if (!this._couponsRendered) { var self = this; api('GET', '/cart.js').then(function (r) { self._renderCoupons(r.json); }); }
    }

    /* ---------- cupom: o Liquid não vê cupom de frete; /cart.js traz discount_codes ---------- */
    _renderCoupons(cart) {
      this._couponsRendered = true;
      var box = this.querySelector('[data-tcd-coupon-applied]');
      var form = this.querySelector('[data-tcd-coupon-form]');
      if (!box || !form) return;
      var codes = ((cart && cart.discount_codes) || []).filter(function (c) { return c.applicable; });
      var toggle = this.querySelector('[data-tcd-coupon-toggle]');
      if (!codes.length) { box.hidden = true; box.innerHTML = ''; if (toggle) toggle.hidden = false; return; }
      box.innerHTML = codes.map(function (c) {
        return '<span>✅ Cupom <strong>' + c.code.replace(/[<>&"]/g, '') + '</strong> aplicado!</span>' +
          '<button type="button" data-tcd-action="coupon-remove">remover</button>';
      }).join('');
      box.hidden = false;
      form.hidden = true; if (toggle) toggle.hidden = true; // com cupom aplicado, o campo some: não cabe outro
    }
    _couponMessage(text, ok) {
      var el = this.querySelector('[data-tcd-coupon-msg]');
      if (!el) return;
      var form = this.querySelector('[data-tcd-coupon-form]'), toggle = this.querySelector('[data-tcd-coupon-toggle]');
      if (form && form.hidden && toggle && !toggle.hidden && ok !== true) { form.hidden = false; toggle.setAttribute('aria-expanded', 'true'); var lbl = toggle.querySelector('.tcd__coupon-toggle-right'); if (lbl) lbl.textContent = 'Fechar'; }
      el.textContent = text; el.hidden = false;
      el.classList.toggle('is-ok', ok === true);
      el.classList.toggle('is-kit', ok === 'kit');
    }
    _toast(text) { this._couponMessage(text, false); }

    /* ---------- frete por CEP: taxas reais da loja via /cart/shipping_rates.json ---------- */
    _ufDoCep(cep) {
      var n = parseInt(cep.slice(0, 5), 10);
      var faixas = [[1000,19999,'SP'],[20000,28999,'RJ'],[29000,29999,'ES'],[30000,39999,'MG'],[40000,48999,'BA'],[49000,49999,'SE'],[50000,56999,'PE'],[57000,57999,'AL'],[58000,58999,'PB'],[59000,59999,'RN'],[60000,63999,'CE'],[64000,64999,'PI'],[65000,65999,'MA'],[66000,68899,'PA'],[68900,68999,'AP'],[69000,69299,'AM'],[69300,69399,'RR'],[69400,69899,'AM'],[69900,69999,'AC'],[70000,73699,'DF'],[73700,76799,'GO'],[76800,76999,'RO'],[77000,77999,'TO'],[78000,78899,'MT'],[79000,79999,'MS'],[80000,87999,'PR'],[88000,89999,'SC'],[90000,99999,'RS']];
      for (var i = 0; i < faixas.length; i++) if (n >= faixas[i][0] && n <= faixas[i][1]) return faixas[i][2];
      return '';
    }
    _shipMessage(text) {
      var box = this.querySelector('[data-tcd-ship-result]'); if (!box) return;
      box.hidden = false; box.innerHTML = '<p class="tcd__ship-msg">' + text + '</p>';
    }
    estimateShipping(cep) {
      var self = this, uf = this._ufDoCep(cep);
      if (!uf) { this._shipMessage('CEP não reconhecido.'); return; }
      var btn = this.querySelector('[data-tcd-ship-submit]'); if (btn) btn.disabled = true;
      this._shipMessage('Calculando…');
      var url = root() + '/cart/shipping_rates.json?shipping_address[zip]=' + cep + '&shipping_address[country]=BR&shipping_address[province]=' + uf;
      var tentativa = 0;
      var pedir = function () {
        return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) {
          if (r.status === 202 && tentativa++ < 6) return new Promise(function (res) { setTimeout(res, 1000); }).then(pedir);
          return r.json().then(function (j) { return { ok: r.ok, json: j }; });
        });
      };
      pedir().then(function (r) {
        if (btn) btn.disabled = false;
        var rates = (r.json && r.json.shipping_rates) || [];
        if (!r.ok || !rates.length) { self._shipMessage('Não encontramos opções de entrega para este CEP.'); return; }
        var prazo = function (rate) {
          var d = rate.delivery_days || rate.delivery_range; if (Array.isArray(d) && d.length) return d;
          var m = (rate.name || '').match(/(\d+)\s*(?:a|-|até)\s*(\d+)/); if (m) return [parseInt(m[1], 10), parseInt(m[2], 10)];
          var m1 = (rate.name || '').match(/(\d+)\s*dia/); if (m1) return [parseInt(m1[1], 10), parseInt(m1[1], 10)];
          return null;
        };
        // ordena pelo que CHEGA ANTES; empate = mais barato
        rates.sort(function (a, b) { var pa = prazo(a), pb = prazo(b); var ma = pa ? pa[pa.length - 1] : 999, mb = pb ? pb[pb.length - 1] : 999; return (ma - mb) || (parseFloat(a.price) - parseFloat(b.price)); });
        var money = function (v) { var n = parseFloat(v); return n === 0 ? 'Grátis' : 'R$ ' + n.toFixed(2).replace('.', ','); };
        var html = rates.slice(0, 4).map(function (rate) {
          var p = prazo(rate);
          var ptxt = p ? (p[0] === p[p.length - 1] ? p[0] + ' dia' + (p[0] > 1 ? 's' : '') + ' úteis' : p[0] + ' a ' + p[p.length - 1] + ' dias úteis') : '';
          return '<div class="tcd__ship-opt"><span class="tcd__ship-name">' + String(rate.name).replace(/[<>]/g, '') + (ptxt ? '<small>' + ptxt + '</small>' : '') + '</span><strong' + (parseFloat(rate.price) === 0 ? ' class="tcd__free"' : '') + '>' + money(rate.price) + '</strong></div>';
        }).join('');
        html = '<p class="tcd__ship-title">Entrega para <strong>' + cep.slice(0, 5) + '-' + cep.slice(5) + '</strong> <button type="button" data-tcd-action="ship-clear">alterar</button></p>' + html;
        self._shipHtml = html; self._shipCep = cep;
        var precos = rates.map(function (x) { return parseFloat(x.price); });
        self._shipResumo = precos.some(function (v) { return v === 0; }) ? 'Grátis' : 'a partir de ' + money(Math.min.apply(null, precos));
        try { localStorage.setItem('tcd_cep', cep); } catch (e) {}
        self._renderShip();
      }).catch(function () { if (btn) btn.disabled = false; self._shipMessage('Não deu para calcular agora. Tente de novo.'); });
    }
    _renderShip() {
      var box = this.querySelector('[data-tcd-ship-result]'), form = this.querySelector('[data-tcd-ship-form]'), hint = this.querySelector('[data-tcd-ship-hint]');
      if (!box) return;
      var freteDd = this.querySelector('[data-tcd-frete]');
      if (this._shipHtml) { box.hidden = false; box.innerHTML = this._shipHtml; if (form) form.hidden = true; if (hint) hint.hidden = true; if (freteDd && this._shipResumo && !/Grátis/.test(freteDd.textContent)) freteDd.innerHTML = this._shipResumo === 'Grátis' ? '<span class="tcd__free">Grátis</span>' : this._shipResumo; }
      else { box.hidden = true; box.innerHTML = ''; if (form) form.hidden = false; if (hint) hint.hidden = false; var inp = this.querySelector('[data-tcd-ship-cep]'); var cep = ''; try { cep = localStorage.getItem('tcd_cep') || ''; } catch (e) {} if (inp && cep && !inp.value) inp.value = cep.slice(0, 5) + '-' + cep.slice(5); }
    }

    /* ---------- contador: data fixa (nunca reinicia) ou diário (meia-noite do visitante) ---------- */
    _startTimer() {
      var el = this.querySelector('[data-tcd-timer]');
      if (this._timer) { clearInterval(this._timer); this._timer = null; }
      if (!el) return;
      var fim = function () {
        if (el.dataset.tcdTimerMode === 'fixo') {
          var raw = el.dataset.tcdTimer || '';
          return new Date(raw.replace(' ', 'T') + (raw.length <= 16 ? ':00-03:00' : ''));
        }
        var d = new Date(); d.setHours(24, 0, 0, 0); return d; // próxima meia-noite
      };
      var end = fim();
      if (isNaN(end.getTime())) return;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var hE = el.querySelector('[data-tcd-h]'), mE = el.querySelector('[data-tcd-m]'), sE = el.querySelector('[data-tcd-s]');
      var tick = function () {
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) {
          if (el.dataset.tcdTimerMode === 'fixo') { el.hidden = true; clearInterval(this._timer); return; }
          end = fim(); s = Math.floor((end - Date.now()) / 1000);
        }
        el.hidden = false;
        hE.textContent = pad(Math.floor(s / 3600)); mE.textContent = pad(Math.floor((s % 3600) / 60)); sE.textContent = pad(s % 60);
      }.bind(this);
      tick(); this._timer = setInterval(tick, 1000);
    }

    /* ---------- Black November: presentes por faixa de valor (R$ 199 calcinha, R$ 299 + protetor) ----------
       Os presentes entram pelo seletor do carrinho (propriedade _brinde_auto = faixa1/faixa2). Aqui só garantimos as guardas:
       valor abaixo da faixa = o presente sai; no máximo 1 de cada; presente nunca sozinho. Valor = peças PRINCIPAL/INFLU (e -cliente depois da data). */
    _applyFaixas(cart) {
      var script = this.querySelector('[data-tcd-bn]');
      if (!script || this._giftLock || !cart) return;
      var cfg; try { cfg = JSON.parse(script.textContent); } catch (e) { return; }
      var items = cart.items || [], now = Date.now();
      var gifts = items.filter(function (i) { return i.properties && /^faixa\d$/.test(i.properties._brinde_auto || ''); });
      if (!gifts.length) return;
      var valor = 0;
      items.forEach(function (i) {
        var p = i.properties || {};
        if (p._brinde_auto || p._brinde || p._roleta) return;
        var h = String(i.handle || ''), t = i.product_type;
        var cli = cfg.clientesDesde && now >= cfg.clientesDesde && (/-cliente(-vip)?$/.test(h) || /fecha-mes/.test(h) || h === 'top-faixa-cotton-up-copia');
        if (t === 'PRINCIPAL' || t === 'INFLU' || cli) valor += i.final_line_price || 0;
      });
      (cart.cart_level_discount_applications || []).forEach(function (d) { valor -= d.total_allocated_amount || 0; });
      if (valor < 0) valor = 0;
      var min = { faixa1: cfg.t1, faixa2: cfg.t2 }, visto = {}, ops = [], self = this;
      gifts.forEach(function (g) {
        var f = g.properties._brinde_auto;
        if (valor < (min[f] || 0) || visto[f]) ops.push(function () { return api('POST', '/cart/change.js', { id: g.key, quantity: 0 }); });
        else visto[f] = true;
      });
      if (!ops.length) return;
      this._giftLock = true;
      ops.reduce(function (p, f) { return p.then(f); }, Promise.resolve())
        .then(function () { self._giftLock = false; return self.refresh({ open: false }); })
        .catch(function () { self._giftLock = false; });
    }

    /* ---------- presente automático (regras dos blocos), com as três guardas ---------- */
    _applyGiftRules(cart) {
      var script = this.querySelector('[data-tcd-gift-rules]');
      if (!script || this._giftLock || !cart) return;
      var rules; try { rules = JSON.parse(script.textContent).filter(function (r) { return r.tipo !== 'fim'; }); } catch (e) { return; }
      if (!rules.length) return;
      var items = cart.items || [];
      var gifts = items.filter(function (i) { return i.properties && i.properties._brinde_auto; });
      var reais = items.filter(function (i) { return !(i.properties && (i.properties._brinde_auto || i.properties._brinde)); });
      var domItems = Array.prototype.slice.call(this.querySelectorAll('.tcd__item'));
      var subtotalReal = reais.reduce(function (s, i) { return s + i.final_line_price; }, 0);

      var ganho = null;
      for (var k = 0; k < rules.length && !ganho; k++) {
        var r = rules[k];
        if (r.tipo === 'valor' && subtotalReal >= r.minimo) ganho = r;
        else if (r.tipo === 'produto_cor') {
          var hit = domItems.some(function (n) { return parseInt(n.dataset.productId, 10) === r.gatilhoProduto && (!r.cor || (n.dataset.color || '').toLowerCase() === r.cor.toLowerCase()) && n.dataset.gift !== 'true'; });
          if (hit) ganho = r;
        } else if (r.tipo === 'grupo') {
          var temA = domItems.some(function (n) { return (n.dataset.collections || '').split(',').indexOf(r.grupoA) > -1 && n.dataset.gift !== 'true'; });
          var temB = domItems.some(function (n) { return (n.dataset.collections || '').split(',').indexOf(r.grupoB) > -1 && n.dataset.gift !== 'true'; });
          if (temA && temB) ganho = r;
        }
      }
      // guarda 1: brinde nunca sozinho
      if (!reais.length) ganho = null;

      var self = this;
      var ops = [];
      // guarda 2 e 3: um brinde por carrinho, sem duplicar — remove todo brinde automático que não seja o ganho
      gifts.forEach(function (g) {
        if (!ganho || g.variant_id !== ganho.brindeVariante || gifts.indexOf(g) > 0) ops.push(function () { return api('POST', '/cart/change.js', { id: g.key, quantity: 0 }); });
      });
      var jaTem = ganho && gifts.some(function (g) { return g.variant_id === ganho.brindeVariante; });
      if (ganho && !jaTem && ganho.brindeVariante) ops.push(function () { return api('POST', '/cart/add.js', { items: [{ id: ganho.brindeVariante, quantity: 1, properties: { _brinde_auto: 'sim' } }] }); });
      if (!ops.length) return;
      this._giftLock = true;
      ops.reduce(function (p, f) { return p.then(f); }, Promise.resolve())
        .then(function () { self._giftLock = false; return self.refresh({ open: false }); })
        .catch(function () { self._giftLock = false; });
    }
  }

  window.customElements.define('toda-cart-drawer', TodaCartDrawer);
})();
